import React from "react";
import styled from "styled-components";
import BadgePic from "../../assets/badge.png";
import { Title, Column, Text, Button } from "../theme/index";

const Wrapper = styled.div`
  background: ${props => props.background};
  background-size: cover;
  height: ${props => props.height};
  padding: 2em 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  align-content: flex-end;
  @media (max-width: 1100px) {
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
`;

const Badge = styled.img`
  width: 250px;
  @media (max-width: 400px) {
    margin: 1em 0;
  }
`;

const Div = styled.div`
  width: 250px;
`;

export default function Banner({ id, img, navigate }) {
  return (
    <Wrapper
      background={`url('${img}')`}
      height={id === "home2" ? "600px" : "375px"}
    >
      {id === "home1" && (
        <React.Fragment>
          <Div />
          <Button onClick={() => navigate.push("/findce")}>Find your CE</Button>
          <Column alignitems="center">
            <Badge src={BadgePic} alt="AchieveCE Bagde" />
            <Text textalign="center" white>
              All courses report to CE Broker
              <br /> within 24 hours
            </Text>
          </Column>
        </React.Fragment>
      )}

      {id === "about1" && <Title white>You can trust our content</Title>}
      {id === "about2" && <Title white>FAQ</Title>}
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Banner.jsx